import Index from '../screens/main';
export default Index;
